export enum FormManagementType {
  LAYANAN_BENGKEL = 'LAYANAN_BENGKEL',
  TOYOTA_HOME_SERVICE = 'TOYOTA_HOME_SERVICE',
  BODY_AND_PAINT = 'BODY_AND_PAINT',
  NEW_CAR = 'NEW_CAR',
  PRE_ORDER = 'PRE_ORDER',
  PROMO = 'PROMO',
  BERITA_DAN_TIPS = 'BERITA_DAN_TIPS',
  SUKU_CADANG = 'SUKU_CADANG',
  REVIEW_PRODUK = 'REVIEW_PRODUK',
  CABANG = 'CABANG',
  CABANG_KOTA = 'CABANG_KOTA',
  CABANG_DETAIL = 'CABANG_DETAIL',
  SALES_AGENT = 'SALES_AGENT',
  PRE_ORDER_USED_CAR = 'PRE_ORDER_USED_CAR',
}

export enum FormManagementFormat {
  POPUP = 'POPUP',
  HALAMAN_PENUH = 'HALAMAN_PENUH',
  FORM_TAMBAHAN = 'FORM_TAMBAHAN',
}
